import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../App';
import '../styles/Hero.css';

const Hero = () => {
  const { darkMode } = useTheme();

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <div className="hero-logo">
          <img
            src={darkMode ? "/images/cardslah-text-logo-dark-mode.png" : "/images/cardslah-text-logo.png"}
            alt="CardsLah"
            className="hero-logo-image"
          />
        </div>

        <h1 className="hero-title">
          <span className="title-line title-line-1">
            <span className="comic-text">EVERY TRADE</span>
            <span className="action-burst burst-1">POW!</span>
          </span>
          <span className="title-line title-line-2">
            <span className="comic-text accent">IS A WIN</span>
            <span className="action-burst burst-2">BAM!</span>
          </span>
        </h1>

        <p className="hero-subtitle">
          <span className="subtitle-text">
            Built by collectors, for collectors. CardsLah aims to educate, inspire, and grow
            the Malaysian trading card community. Featuring Pokemon, Yu-Gi-Oh!, Magic: The Gathering,
            One Piece, Digimon, Dragon Ball & more! Every card tells a story of passion,
            nostalgia, and the thrill of discovery.
          </span>
        </p>

        <div className="hero-cta">
          <a href="#events" className="cta-button primary">
            <span className="btn-text">JOIN EVENTS</span>
            <span className="btn-burst">!</span>
            <div className="btn-shine"></div>
          </a>
          <Link to="/cards" className="cta-button secondary">
            <span className="btn-text">VIEW CARDS</span>
            <span className="btn-burst">!</span>
          </Link>
        </div>

        <div className="hero-stats">
          <div className="stat-item">
            <span className="stat-number">50+</span>
            <span className="stat-label">VENDORS</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">10+</span>
            <span className="stat-label">EVENTS</span>
          </div>
          <div className="stat-divider"></div>
          <div className="stat-item">
            <span className="stat-number">1000+</span>
            <span className="stat-label">CARDS</span>
          </div>
        </div>
      </div>

      <div className="hero-visual">
        <div className="card-stack">
          <div className="floating-card card-1">
            <img
              src="https://images.pokemontcg.io/base1/4_hires.png"
              alt="Charizard Base Set"
              className="hero-card-image"
            />
          </div>

          <div className="floating-card card-2">
            <img
              src="https://images.weserv.nl/?url=en.onepiece-cardgame.com/images/cardlist/card/OP01-003.png"
              alt="Luffy One Piece"
              className="hero-card-image"
            />
          </div>

          <div className="floating-card card-3">
            <img
              src="https://images.pokemontcg.io/base1/58_hires.png"
              alt="Pikachu Base Set"
              className="hero-card-image"
            />
          </div>
        </div>

        <div className="energy-orbs">
          <div className="orb orb-1"></div>
          <div className="orb orb-2"></div>
          <div className="orb orb-3"></div>
        </div>
      </div>

      <div className="hero-decoration">
        <div className="speed-lines"></div>
        <div className="halftone-overlay"></div>
        <div className="comic-dots"></div>
      </div>
    </section>
  );
};

export default Hero;
